export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/zipAnalyzer.worker.7ae2a60e.worker.js");
}
